import { atomFamily } from "jotai/utils";

import { UnUploadedImage } from "components/PhotoUpload/types";

import { createDerivedSessionAtom } from "./utils/createDerivedSessionAtom";
import { createPersistedAtom } from "./utils/createPersistedAtom";

const sessionCaiPhotosAtom = atomFamily((sessionId: string) =>
  createPersistedAtom<UnUploadedImage[]>(`caiPhotos-${sessionId}`, [])
);

export const caiPhotosAtom = createDerivedSessionAtom<UnUploadedImage[]>(sessionCaiPhotosAtom);
